import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Input, Label, FormGroup } from 'reactstrap';
import { formResMessage } from 'utils/commonFunc';
import CustomButton from '../../../components/CustomButton';
import ReactMicComp from './ReactMic';

const stateObj = {
  data: {
    formData: '',
    auditDescription: ``,
  },
  errors: {},
  loading: false,
};

class NewActivityFormModal extends React.Component {
  state = stateObj;

  handleChange = e =>
    this.setState({
      data: { ...this.state.data, [e.currentTarget.name]: `${e.currentTarget.value}` },
    });

  handleSubmit = e => {
    e.preventDefault();
    const { data } = this.state;
    const errors = this.validate(data);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.setState({ loading: true });
      this.props
        .sendVoice(data)
        .then(() => {
          this.stateReset();
          this.props.updateSuccess();
        })
        .catch(err => this.setError(err));
    }
  };

  setError = err => {
    this.setState(prevState => ({
      ...prevState,
      errors: {
        global: formResMessage(err),
      },
      loading: false,
    }));
  };

  stateReset = () => {
    this.setState(stateObj);
  };

  formModalClose = () => {
    this.stateReset();
    this.props.formModalCloseProp();
  };

  validate = data => {
    const errors = {};

    if (!data.formData && !data.auditDescription) {
      errors.mediaFile = 'Either Voice or Activity text is required';
    }

    if (!data.formData && !data.auditDescription) {
      errors.auditDescription = 'Either Voice or Activity text is required';
    }

    return errors;
  };

  blobToBase64(blob) {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(new Blob([blob]));
    });
  }

  passMedia = async blob => {
    if (blob) {
      const formData = new FormData();
      let myBlob = await fetch(blob).then(r => r.blob());
      formData.append(
        'file',
        new File([myBlob], new Date().getTime(), {
          type: myBlob.type,
        }),
        new Date().getTime()
      );
      this.setState(prevState => ({ ...prevState, data: { ...prevState.data, formData } }));
    } else {
      this.setState(prevState => ({ ...prevState, data: { ...prevState.data, formData: '' } }));
    }
  };

  render() {
    const { isActivityModalOpen } = this.props;
    const { data, errors, loading } = this.state;
    const thisData = (
      <Modal size="lg" isOpen={isActivityModalOpen}>
        <form onSubmit={this.handleSubmit}>
          <ModalHeader>{'ADD ACTIVITY'}</ModalHeader>
          <ModalBody>
            {errors.global && <div className="mt-10 ml-15 mr-15 pad-12 alert alert-danger">{errors.global}</div>}
            <div className="content">
              <div className="container-fluid">
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <ReactMicComp passMedia={this.passMedia} error={errors.mediaFile} />
                    </FormGroup>
                  </Col>
                </Row>
                <div style={{ textAlign: 'center', paddingBlock: 10 }}>
                  <b>OR</b>
                </div>
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <Label htmlFor="">
                        Enter Manually<sup> *</sup>
                      </Label>
                      <Input
                        type="textarea"
                        name="auditDescription"
                        onChange={this.handleChange}
                        value={data.auditDescription}
                        placeholder="Enter activity here..."
                        maxLength="5000"
                      />
                      {errors.auditDescription && <span className="err-msg">{errors.auditDescription}</span>}
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <CustomButton type="submit" disabled={loading} loading={loading} />
            <CustomButton
              className="ml-2"
              type="button"
              color="default"
              disabled={loading}
              onClick={this.formModalClose}
              name="Cancel"
            />
          </ModalFooter>
        </form>
      </Modal>
    );
    return <div>{thisData}</div>;
  }
}

export default NewActivityFormModal;
